import { Container } from 'inversify'

import {
  CommonIncidentId,
  SoccerIncidentId,
} from '@collector/sportsapi-client-legacy'

import { SoccerRelationIoCBindings } from './SoccerRelationDependencies'

export function bindDisabledIncidentsWithSameTime(ioc: Container): void {
  ioc
    .bind(SoccerRelationIoCBindings.DisabledIncidentsWithSameTime)
    .toDynamicValue(() => {
      return [
        SoccerIncidentId.SubstitutionIn,
        SoccerIncidentId.SubstitutionOut,
        SoccerIncidentId.FirstHalf,
        SoccerIncidentId.SecondHalf,
        SoccerIncidentId.Halftime,
        SoccerIncidentId.ExtratimeFirstHalf,
        SoccerIncidentId.ExtratimeSecondHalf,
        SoccerIncidentId.ExtratimeHalftime,
        SoccerIncidentId.PenaltyShootout,
        SoccerIncidentId.PenaltyShootoutStarted,
        SoccerIncidentId.FreeKick,
        SoccerIncidentId.InPossession,
        SoccerIncidentId.Attack,
        SoccerIncidentId.DangerousAttack,
        SoccerIncidentId.FinishedRegularTime,
        SoccerIncidentId.FinishedAwardedWin,
        SoccerIncidentId.FinishedAfterPenalties,
        SoccerIncidentId.FinishedAfterExtratime,
        CommonIncidentId.Betstart,
        CommonIncidentId.Betstop,
        SoccerIncidentId.CornerMarketsDisabled,
        SoccerIncidentId.CornerMarketsEnabled,
        SoccerIncidentId.BookingMarketsDisabled,
        SoccerIncidentId.BookingMarketsEnabled,
        SoccerIncidentId.AddedTime,
      ]
    })
    .inSingletonScope()
}
